import { defineCopy } from "@tami/core/intl";

import { LEGAL_COPY_EN_US } from "./en-us/legal.copy";
import { LEGAL_COPY_ES_ES } from "./es-es/legal.copy";

/** Título e descrição dos documentos legais (páginas e sitemap). */
export const LEGAL_COPY_PT_BR = {
  terms: {
    title: "Termos de Uso",
    description:
      "Os termos que regem o uso da Tãmi: planos, cobrança, renovação, arrependimento, cancelamento, conta e responsabilidades.",
  },
  privacy: {
    title: "Política de Privacidade",
    description:
      "Como a Tãmi coleta, usa, compartilha e apaga os seus dados, com qual base legal, e quais são os seus direitos sobre eles.",
  },
} as const;

export const LEGAL_COPY = defineCopy(LEGAL_COPY_PT_BR, {
  "en-US": LEGAL_COPY_EN_US,
  "es-ES": LEGAL_COPY_ES_ES,
});
